export const guestComps = {
  detail: {
    nav: {
      overview: "Informacje",
      bookings: "Rezerwacje",
      checkins: "Check-iny",
      invoicing: "Fakturowanie",
    },
    personalInfo: "Dane osobowe",
    contactInfo: "Dane kontaktowe",
    residenceInfo: "Dane o miejscu zamieszkania",
    fields: {
      firstName: "Imię",
      lastName: "Nazwisko",
      document: "Dokument",
      nationality: "Narodowość",
      country: "Kraj",
      birthDate: "Data urodzenia",
      email: "E-mail",
      whatsapp: "WhatsApp",
      countryResidence: "Kraj zamieszkania",
      cityResidence: "Miasto zamieszkania",
      relationship: "Pokrewieństwo",
    },
    cols: {
      code: "Kod",
      accommodation: "Obiekt",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Status",
      total: "Suma",
      guest: "Gość",
      booking: "Rezerwacja",
      entryDate: "Data przyjazdu",
      date: "Data",
    },
    confirmed: "Potwierdzona",
    fiscalProfile: "Zapisany profil podatkowy",
    legalName: "Nazwa firmy",
    taxId: "NIP",
    type: "Rodzaj",
    company: "Firma",
    individual: "Osoba prywatna",
    invoicesIssued: "Wystawione faktury",
    empty: {
      bookings: "Brak zapisanych rezerwacji dla tego gościa.",
      checkins: "Brak zapisanych check-inów dla tego gościa.",
      invoices: "Brak faktur wystawionych dla tego gościa.",
    },
    noPdf: "Brak PDF",
    status: {
      sent: "Wystawiona",
      processing: "Przetwarzanie",
      error: "Błąd",
      pending: "Oczekuje",
    },
    close: "Zamknij",
  },
  form: {
    editTitle: "Edytuj klienta",
    newTitle: "Nowy klient",
    subtitle: "Dane kontaktowe i do faktur na potrzeby przyszłych rezerwacji i dokumentów.",
    subtitleEmbedded: "Uzupełnij profil, a wrócisz do faktury bez utraty opłat.",
    backToInvoice: "Powrót do faktury",
    close: "Zamknij",
    customerTypeAria: "Rodzaj klienta",
    typeIndividual: "Osoba prywatna",
    typeIndividualHelp: "Osoba fizyczna",
    typeCompany: "Firma",
    typeCompanyHelp: "Osoba prawna",
    identity: "Tożsamość",
    identityDesc: "Dane, które identyfikują odbiorcę faktury.",
    name: "Imię",
    namePlaceholder: "Jan",
    lastName: "Nazwisko",
    lastNamePlaceholder: "Kowalski",
    legalName: "Nazwa firmy",
    legalNamePlaceholder: "Przykładowa Firma Sp. z o.o.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Dokument podatkowy",
    docPlaceholderIndividual: "DNI, NIE lub paszport",
    docType: "Rodzaj dokumentu",
    select: "Wybierz",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Paszport",
    docOther: "Inny dokument",
    contact: "Kontakt",
    contactDesc: "Kanały do wysłania faktury lub kontaktu z klientem.",
    email: "E-mail",
    emailPlaceholder: "klient@email.com",
    phone: "Telefon",
    fiscalAddress: "Adres do faktury",
    fiscalAddressDesc: "Używany jako adres odbiorcy na pełnej fakturze.",
    country: "Kraj",
    address: "Adres",
    addressPlaceholder: "Ulica, numer i piętro",
    city: "Miasto",
    cityPlaceholder: "Madrid",
    state: "Województwo / region",
    postalCode: "Kod pocztowy",
    postalPlaceholder: "28001",
    requiredNote: "* Pola wymagane w profilu podatkowym",
    backToInvoiceShort: "Powrót do faktury",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveChanges: "Zapisz zmiany",
    createClient: "Utwórz klienta",
    err: {
      name: "Podaj imię.",
      lastName: "Podaj nazwisko.",
      legalName: "Podaj nazwę firmy.",
      taxId: "Identyfikacja podatkowa jest wymagana w przypadku firm.",
      country: "Wybierz kraj.",
      address: "Podaj adres do faktury.",
      city: "Podaj miasto.",
      postalCode: "Podaj kod pocztowy.",
      email: "Podaj prawidłowy adres e-mail.",
      saveFailed: "Nie udało się zapisać klienta.",
    },
  },
  list: {
    title: "Klienci do faktur",
    subtitle: "Profile podatkowe wielokrotnego użytku do wystawiania i przeglądania faktur",
    searchLabel: "Szukaj klientów",
    searchPlaceholder: "Nazwa, e-mail, telefon lub dokument…",
    clearSearch: "Wyczyść wyszukiwanie",
    exporting: "Eksportowanie...",
    exportClients: "Eksportuj klientów",
    newClient: "Nowy klient",
    cols: {
      fiscalClient: "Klient podatkowy",
      contact: "Kontakt",
      fiscalDocument: "Dokument podatkowy",
      country: "Kraj",
      linkedBookings: "Powiązane rezerwacje",
      invoices: "Faktury",
      actions: "Akcje",
    },
    company: "Firma",
    individual: "Osoba prywatna",
    noEmail: "Brak przypisanego e-maila",
    noPhone: "Brak przypisanego telefonu",
    viewInvoicesTitle: "Zobacz {count} fakturę tego gościa | Zobacz {count} faktury tego gościa | Zobacz {count} faktur tego gościa",
    invoicesCount: "{count} faktura | {count} faktury | {count} faktur",
    noInvoices: "Brak faktur",
    editClient: "Edytuj klienta",
    edit: "Edytuj",
    viewDetail: "Zobacz szczegóły",
    view: "Zobacz",
    emptySearchTitle: "Nie znaleziono profili podatkowych",
    emptySearchSub: "Żaden klient do faktur nie pasuje do „{term}”.",
    emptyTitle: "Nie ma jeszcze klientów do faktur",
    emptySub: "Utwórz profil podatkowy przy wystawianiu faktury albo zapisz go teraz, aby użyć go później.",
    createFirst: "Utwórz pierwszego klienta",
    selectedClient: "Wybrany klient",
  },
  internalName: {
    addBtn: "nazwa wewnętrzna",
    title: "Nazwa wewnętrzna",
    hint: "Widzisz ją tylko Ty. Pojawia się przed nazwą publiczną na listach i w kalendarzach.",
    removeWarn: "Zostanie usunięta z Twoich list. Wiadomości z kodami dostępu i Agent AI nie będą już wskazywać, o który obiekt chodzi.",
    edit: "Edytuj",
    cancel: "Anuluj",
    removing: "Usuwanie…",
    confirmRemove: "Tak, usuń",
    remove: "Usuń",
    editTitle: "Edytuj nazwę wewnętrzną",
    addTitle: "Dodaj nazwę wewnętrzną",
    eyebrow: "Nazwa wewnętrzna obiektu",
    modalHint: "Prywatna nazwa, dzięki której rozpoznasz obiekt na pierwszy rzut oka (na przykład «Poddasze Roser» albo «Drugie»). Goście nigdy jej nie widzą.",
    placeholder: "Poddasze Roser",
    previewLabel: "Tak to zobaczysz",
    saving: "Zapisywanie…",
    save: "Zapisz",
    saveFailed: "Nie udało się zapisać nazwy wewnętrznej.",
  },
};
